import { Pipe, PipeTransform } from '@angular/core';

import { gmaPrecipitationTypeMapping } from '../constants/constants';

@Pipe({ name: 'gmaPrecipitationTypeMapping' })
export class GmaPrecipitationTypeMappingPipe implements PipeTransform {
  transform(value: number, stationSource: any) {
    return gmaPrecipitationTypeMapping(value, stationSource);
  }
}
